<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { isDark } from '@/utils/is'
import { useDesign } from '@/hooks/web/useDesign'
import { useCache } from '@/hooks/web/useCache'
import { useI18n } from '@/hooks/web/useI18n';
import { APP_VERSION } from './config/global'
import { getAgentSettings } from './api/iknowledge'
import { useCommonStoreWithOut } from './store/modules/common'
import { checkUrlAccessibility } from './utils'
import { GetDeskApps } from './api/desk'
const { t } = useI18n()
const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

const { wsCache } = useCache()

// 根据浏览器当前主题设置系统主题色
// const setDefaultTheme = () => {
//   if (wsCache.get('isDark')) {
//     appStore.setIsDark(wsCache.get('isDark'))
//     return
//   }
//   const isDarkTheme = isDark()
//   appStore.setIsDark(isDarkTheme)
// }

// setDefaultTheme()

const setTitle = ()=>{
  appStore.setTitle(t('router.title'))
}
setTitle()
appStore.setVersion(APP_VERSION)

const commonStore = useCommonStoreWithOut()

const agentUrl = computed(() => {
    let url = (window as any).$ikorigin
    url = url.replace('portal-ikonwledge','portal-iknowledge').replace(/\/+$/, '')
    return `${url}/#/agent/mu`
})

onMounted(async () => {
  // getAgentSettings(null).then(res => {
  //   if (!res) throw new Error('')
  //   if (res.errorCode !== 0) throw new Error(res.errorMessage)
  //   commonStore.setAgentSettings(res ?? {})
  // }).catch(err => {
  //   console.log(err)
  // })
  // checkUrlAccessibility(agentUrl.value).then(res => {
  //   console.log('agentEnable:', res)
  //   commonStore.setAgentEnable(res)
  // }).catch(err => {
  //   console.log(err)
  // })
  
  // if (process.env.NODE_ENV !== 'production') {
  //   commonStore.setAgentEnable(true)
  //   return
  // }
  GetDeskApps({withoutImage:true}).then(res => {
    if (res && res.code === 200) {
      // console.log(res.data)
      if (res.data.find(app => app.service === 'iMachineAgent' && app.bind)) {
        commonStore.setAgentEnable(true)
      }
    }
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    console.log('agentEnable:', commonStore.getAgentEnable)
  })
})
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{namespace}-app';

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: relative;
  .size;

  #app {
    .size;
    // transform: scale(1);
  }
  .el-popper.is-dark {
      position: absolute !important;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>
